import SiteEnum from './enums/SiteEnum';
import ThemeEnum from './enums/ThemeEnum';
import VariantTypeEnum from './enums/VariantTypeEnum';
import { IImage, IImageWithAltText } from './IImage';
import { ILink } from './ILink';
import { IVideo } from './IVideo';

export interface IHeroBase {
  readonly backgroundColour?: string;
  readonly backgroundImage?: IImage;
  readonly deactivateAutoplay?: boolean;
  readonly fontColour: ThemeEnum;
  readonly imageBlock?: IImageWithAltText;
  readonly playButtonLabel: string;
  readonly site: SiteEnum;
  readonly subText?: string;
  readonly title?: string;
  readonly trumpetText?: string;
  readonly variant: HeroVariantEnum;
  readonly video?: IVideo;
  readonly videoConfig: string;
}
export interface IArticleHeader extends IHeroBase {
  readonly hasPlayButton: boolean;
}

export interface IMediaHero extends IHeroBase {
  readonly ctaOne?: ILink;
  readonly ctaStyle?: VariantTypeEnum;
  readonly ctaTwo?: ILink;
  readonly hasQBrickPlayButton: boolean;
  readonly imageBlock?: IImageWithAltText;
  readonly trumpetImageBlock?: IImageWithAltText;
}

export enum HeroVariantEnum {
  Full = 'fullWidth',
  FullLarge = 'fullWidthLargeText',
  Split = 'split',
  SplitReverse = 'splitReverse',
  Stacked = 'stacked',
}
